import { createFileRoute } from "@tanstack/react-router";

import { INCIDENT_TYPE_QUERY } from "@/features/settings/incident-types/graphql/incident-type";
import { IncidentType } from "@/features/settings/incident-types/incident-type";

export const Route = createFileRoute("/_authenticated/settings/incident-types/$id")({
  component: IncidentType,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(INCIDENT_TYPE_QUERY, { id: params.id })
        .toPromise();
    }
  },
});
